module.exports = __webpack_public_path__ + "img/main_center@3x.6e1327ef.png";